import * as React from 'react';
import TradePage from '../../../common/components/TradePage/TradePage';
import GTPFlowPageSubtitle from '../GTPFlowPageSubtitle/GTPFlowPageSubtitle';
import config from '../../../store/mmd/config';
import { IEstimateLoanBalanceUIProps } from './EstimateLoanBalanceInterfaces';
import { ButtonText } from '../constants';
import { Input } from '@makemydeal/ui-bricks/dist/cox';
import { formatUtils } from '@makemydeal/dr-common-utils';
import { LoadingButtonUI } from '@makemydeal/dr-activities-common';
import { ChangeEvent } from 'react';

const ESTIMATE_LOAN_INPUT = { label: 'How much do you still owe?', placeHolder: '$5000' };

export const EstimateLoanBalanceUI: React.FC<IEstimateLoanBalanceUIProps> = (props) => {
    const {
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        goToRoute,
        dispatchAnalytics,
        renderDisclaimer,
        vehicleName,
        goBack,
        removeTrade,
        amountOwed,
        selectedLoanBalanceOption,
        tradeIndex,
        urlPath
    } = props;

    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        props.onInputValueChange(event.target.value || '');
    };

    const isNumber = (val: string) => {
        return /^[0-9]+$/.test(val.trim());
    };

    const handleNumberFormat = (val: string) => {
        if (!isNumber(val)) return '';
        return formatUtils.formatCurrencyAmount(parseInt(val));
    };

    return (
        <TradePage
            headerOnTop
            showCustomTitle
            pageClass="dr-estimate-loan-balance-page"
            pageTitle={pageTitle}
            pageSubTitle={<GTPFlowPageSubtitle pageSubtitle={pageSubTitle} suffix={vehicleName} tradeIndex={tradeIndex} />}
            renderDisclaimer={renderDisclaimer}
            goToRoute={goToRoute}
            dispatchAnalytics={dispatchAnalytics}
            footerProps={{
                fullWidthLayout: true,
                showBackButton: true,
                onBackButtonClick: () => goBack(selectedLoanBalanceOption),
                showSkipButton: true,
                skipButtonText: 'Cancel Trade-in',
                onSkipButtonClick: removeTrade
            }}
            stepperRoutes={stepperRoutes}
            showTradeErrorMessage={false}
            staticAssetsConfig={config.staticImages}
            stepLabelVisible={true}
            isStepperClickable={false}
            urlPath={urlPath}
        >
            <section className="dr-estimate-loan-balance-container">
                <h3 className="dr-estimate-loan-balance-header">Estimate your loan balance</h3>
                <p className="dr-estimate-loan-balance-subheader">We'll confirm the exact amount before finalizing your purchase</p>
                <div className="dr-estimate-input-wrapper">
                    <Input
                        label={ESTIMATE_LOAN_INPUT.label}
                        name="how-much-do-you-own"
                        type="text"
                        inputId="how-much-do-you-own"
                        value={!isNaN(amountOwed) && String(amountOwed)}
                        pattern="[0-9]*"
                        inputmode="numeric"
                        maxlength={12}
                        placeholder={ESTIMATE_LOAN_INPUT.placeHolder}
                        disabled={false}
                        onChangeFunction={handleOnChange}
                        className="dr-estimate-loan-balance-input"
                        formatValueFunction={handleNumberFormat}
                    />
                </div>
                <div className="btn-ui-wrapper">
                    <LoadingButtonUI
                        buttonText={ButtonText.Continue}
                        disabled={!amountOwed}
                        isPending={false}
                        id="action_footer_bar_action_button"
                        dataTestId="dr-estimate-loan-action-button"
                        isSubmit={true}
                        onClick={props.next}
                        additionalClassParams="estimate_loan_action_button"
                    />
                </div>
            </section>
        </TradePage>
    );
};

export default EstimateLoanBalanceUI;
